import { render, staticRenderFns } from "./AgeBar.vue?vue&type=template&id=27acef73&scoped=true&"
import script from "./AgeBar.vue?vue&type=script&lang=js&"
export * from "./AgeBar.vue?vue&type=script&lang=js&"
import style0 from "./AgeBar.vue?vue&type=style&index=0&id=27acef73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27acef73",
  null
  
)

export default component.exports